import { z } from "zod";
import { trimmedString } from "../utils/trimmedString";
import { nameRegex } from "../validationRegex";
export const getNameSchema = (t, opts) => {
    const { isSingleFieldNameInput } = opts;
    const nameMin = 2;
    const makeNameField = (emptyKey, invalidKey) => trimmedString({ emptyMessage: t(emptyKey) })
        .min(nameMin, { message: t(emptyKey) })
        .refine((v) => nameRegex.test(v), { message: t(invalidKey) });
    if (isSingleFieldNameInput) {
        return z.object({
            fullName: makeNameField("contact.form.lastname_error_empty", "contact.form.lastname_error_invalid"),
            firstName: z.string().optional(),
            lastName: z.string().optional(),
        });
    }
    return z.object({
        firstName: makeNameField("contact.form.firstname_error_empty", "contact.form.firstname_error_invalid"),
        lastName: makeNameField("contact.form.lastname_error_empty", "contact.form.lastname_error_invalid"),
        fullName: z.string().optional(),
    });
};
